import { render } from "./LegalVersions.vue?vue&type=template&id=85b4ad10"
import script from "./LegalVersions.vue?vue&type=script&lang=js"
export * from "./LegalVersions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__